export { default } from "components/Atoms/CategoryDivider/CategoryDivider";
